<template>
  <v-skeleton-loader
    :loading="!content.thumbnail"
    type="card"
    transition="scale-transition"
  >
    <v-card class="ma-0 pa-0" max-width="220">
      <v-card-text class="pa-0 ma-0">
        <v-img :src="thumbnail" v-if="content.type.startsWith('image/')" />
        <video-player
          v-if="content.type.startsWith('video/')"
          :source="source"
          :poster="thumbnail"
          :options="{
            autoplay: false,
            controls: true,
            fluid: true,
            responsive: true
          }"
          ref="player"
        >
        </video-player>
      </v-card-text>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import firebase from 'firebase'
import VideoPlayer from '@/components/media/VideoPlayer'

export default {
  name: 'ContentCard',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  components: {
    VideoPlayer
  },
  data: () => ({
    thumbnail: '',
    source: ''
  }),
  mounted() {
    if (this.content.url && this.content.thumbnail) {
      firebase
        .storage()
        .ref()
        .child(this.content.url)
        .getDownloadURL()
        .then(url => {
          this.source = url
        })
      firebase
        .storage()
        .ref()
        .child(this.content.thumbnail)
        .getDownloadURL()
        .then(url => {
          this.thumbnail = url
        })
    }
  }
}
</script>
